export const loadingSlideKeys = {
  active: (params?: { iataCode?: string; originIataCode?: string }) =>
    ['loading-slides', 'active', params?.originIataCode ?? null, params?.iataCode ?? null] as const,
  all: ['loading-slides'] as const,
}
